import React from 'react';
import PostsList, { PostsListProps } from '@components/posts-list/relative-posts-list';
import Section from '@components/section';
import Wrapper from '@components/wrapper.styled';
import { StyledTitle } from './relative-posts.styled';

interface RelativePostsProps {
  edges: PostsListProps['edges'];
  title: string;
  postsType: string;
}

const RelativePosts = ({ edges, title, postsType }: RelativePostsProps): JSX.Element => (
  <Section backgroundColor="primary">
    <Wrapper>
      {title && (
        <StyledTitle
          type="title"
          stringText={title}
          fontColor="secondary"
          fontSize="heading2"
          margin="md"
        />
      )}
    </Wrapper>
    <PostsList edges={edges} postsType={postsType} />
  </Section>
);

export default RelativePosts;
